import React from 'react';
import cN from 'classnames';
import './index.less';
import Image from 'next/image';

const BrandListImage = () => (
  <>
    {/* eslint-disable-next-line @next/next/no-img-element */}
    <Image
      src="https://static.pietrastudio.com/public/file_uploads/dbee81c1efea0988411b1b28fa71ded5.png"
      sizes="(max-width: 1100px) 0,(min-width: 1100px) 250px, 0"
      quality={80}
      alt="brand images list"
      width={250}
      height={2351}
      loading="lazy"
    />
  </>
);

const MakeItHappenNow = ({
  className,
  title = 'Make it happen now with Pietra.',
  desc = 'Join the 300,000+ brands & entrepreneurs on Pietra',
  btnText = 'Get started for FREE',
  style = {},
  btnOnclick = () => {},
}: {
  className?: string;
  title?: string;
  desc?: string;
  btnText?: string;
  style?: React.CSSProperties;
  btnOnclick?: () => void;
}) => {
  return (
    <div className={cN('marking-it-happen-container', className)} style={style}>
      <div className="left-container">
        <p className="title">{title}</p>
        <p className="desc">{desc}</p>
        <button className="happen-button" onClick={btnOnclick}>
          {btnText}
        </button>
      </div>

      <div className="carousel-image-container">
        <div className="left">
          <BrandListImage />
          <BrandListImage />
        </div>
        <div className="right">
          <BrandListImage />
          <BrandListImage />
        </div>
      </div>
    </div>
  );
};

export default MakeItHappenNow;
